<template>
    <div class="wxSign wxNoscroll">
        <wxBack></wxBack>
        <div class="bgShow" style="padding-bottom: 100px;">
    	
        <ml-i-view v-model="modalSign" :url="wxSignBig" :scale="4"></ml-i-view>
        <Modal
    	class="wxSignModal"
        v-model="modalSign2" 
        title="报名名单"
        >
        <!--<span v-show="!maxSecond">持续显示菜单</span>-->
        <span v-show="getArrLength(peopleList)">暂无参加人员</span>
        <span style="font-size: 4vw;margin-right: 4vw;" v-for="(item,$index) in peopleList">{{$index+1}}、{{item.realname}}</span>
        </Modal>
            <Row>
                <h3 style="text-align:center;word-break: break-all;">{{title}}</h3>
                <!--<div style="text-align:center">截至时间{{stopTime}}</div>-->
                <div ref="wxSingEditer2" class="rightConL">
                	<swiper v-show="checkout(showIt.image)" :options="swiperOption2" ref="mySwiper2">
                		<swiper-slide class="swiperCss" v-for="(item2,index2) in showIt.image" :key="index2">
                			<img style="width: 100%;height: 40vw;object-fit: contain;margin-top: 10vw;" :src="addQian(item2.url)" alt="" />
                		</swiper-slide>
                	</swiper>
					<iframe v-show="!checkout(showIt.image)" style="margin: 0 auto;display: block;width: 90%;" frameborder="0" :src="addQian2(showIt)" allowfullscreen></iframe>
                	<!--<video controls="" autoplay="" name="media" v-show="!checkout(showIt.image)" v-for="(item2,index2) in showIt.video" style="margin: 0 auto;display: block;width: 90%;">
                		<source :src="addQian(item2.url)" type="video/mp4"></source>
                	</video>-->
                </div>
                <div ref="wxSingEditer" class="content ql-editor" id="wxSingEditer" style="min-height : 30vh;padding : 4vw;" v-html="content"></div>
            </Row>
            <Row style="text-align : center;">
                <Button style="margin-bottom: 30px;" @click="showNum" type="success">报名名单</Button>
                <Button @click="cancel" v-show="isJoinB && !isOldB" type="error">取消报名</Button>
                <Button @click="sign" v-show="!isJoinB && !isOldB" type="success">报名</Button>
                <Button disabled v-show="isOldB" type="error">已过期</Button>
            </Row>
        </div>
        <wxNav></wxNav>
    </div>
</template>


<script>
	import "assets/../global/setting";
    import { mapState, mapGetters, mapMutations } from "vuex";
    import "assets/../global/jq";
    import wxBack from "../wxBack"
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    import wxNav from "../wxNav"
    export default {
        props:["username","id"],
        data () {
          return{
          		modalSign2:false,
          		peopleList:[],
          		modalSign:false,
          		wxSignBig:"",
          		swiperOption2: {
		          observer:true,
				  observeParents:true,
                  debugger: true,
		          autoplay: {
				    delay: 3000,
				    stopOnLastSlide: false,
				  },
                },
                showIt: {},
                title: "",
                content: "",
                stopTime : "",
                isJoinB: false,
                isOldB: false,
                _id: ""
            }
        },
        components:{
            wxNav,
            swiper,
            wxBack,
            swiperSlide
        },
        methods:{
            ...mapMutations(["SET_LOADING"]),
        	cancelIt(){
        		this.modalSign = false;
        	},
        	getArrLength(arr){
		  		if(arr.length>0){
		  			return false;
		  		}else{
		  			return true;
		  		}
		  	},
        	showNum(){
        		this.getPeopleList();
        		this.modalSign2 = true;
        	},
        	addQian2(path){
        		var arr = [];
        		for (var i in path){
        			arr.push(i);
        		}
        		if(arr.length>0){
        			if(path.video.length>0){
        				var ele = path.video[0].url.split(parameters.domain).length - 1;
		    			return parameters.domain+path.video[0].url.split(parameters.domain)[ele];
        			}
        		}
        	},
        	addQian(path) {
				var ele = path.split(parameters.domain).length - 1;
		    	return parameters.domain+path.split(parameters.domain)[ele];
		    },
        	checkout(e){
        		var arr = [];
        		for(var i in e){
        			arr.push(i);
        		}
        		if(arr.length<2){
        			return false;
        		}else{
        			return true;
        		}
        	},
        	getUrl(e){
        		return parameters.domain + e;
        	},
            //报名
            sign() {
                let params = {};
                var that = this;
                params.data = {
                    "is_join" : true,
                    "_id" : this._id
                };
                params.url = "/sys/receiveuser/edit";
                params.token = "swgykj9527";
                params.success = function(res) {
                    if(res.data.code == "0000"){
                        that.$Message.success("报名成功");
                        that.getContent();
                    }
                };
                if(new Date().format("yyyy-MM-dd hh:mm:ss") > this.stopTime){
        			this.$Message.error("活动已过期");
					this.getList();
	            }else{
                	this.ajaxPostWX(params);
	            }
            },
            //是否过期
            isOld(){
                if(new Date().format("yyyy-MM-dd hh:mm:ss") > this.stopTime){
                    this.isOldB = true;
                }else{
                    this.isOldB = false;
                }
            },
            isJoin(){
                if(!this.isOldB && this.isJoinB){
                    this.isJoinB =  true;
                }else if(!this.isOldB && !this.isJoinB){
                    this.isJoinB = false;
                }
            },
            cancel(){
            	let params = {};
                var that = this;
                params.data = {
                    "_id" : this._id,
                    is_join: false
                };
                params.url = "/sys/receiveuser/edit";
                params.token = "swgykj9527";
                params.success = function(res) {
                   that.getList();
                };
                this.ajaxPostWX(params);
            },
            getList(){
                let params = {};
                var that = this;
                params.data = {
                    searchValue: {
                        "username": this.username,
                        "id" : this.id
                    }
                };
                params.url = "/sys/receiveuser/list";
                params.token = "swgykj9527";
                params.success = function(res) {
                   that.isJoinB = res.data.result.result[0].is_join;
                   that._id = res.data.result.result[0]._id;
                   that.isOld();
                   that.isJoin();
                };
                this.ajaxPostWX(params);
            },
            showImg(){
            	var that = this;
            	$(this.$refs.wxSingEditer).click(function(e){
            		if(e.target.localName == "img"){
            			that.modalSign = true;
            			that.wxSignBig = $(e.target).attr("src");	
            		}
            	});
            	$(this.$refs.wxSingEditer2).click(function(e){
            		if(e.target.localName == "img"){
            			that.modalSign = true;
            			that.wxSignBig = $(e.target).attr("src");	
            		}
            	});
            },
            getContent(){
                let params = {};
                var that = this;
                params.data = {
                    searchValue: {
                        "id" : this.id
                    }
                };
                params.url = "/manage/messagelist/list";
                params.token = "swgykj9527";
                params.success = function(res) {
                   that.showIt2 = res.data.result.result[0];
                   that.showIt = res.data.result.result[0];
                   that.title = res.data.result.result[0].title;
                   that.content = res.data.result.result[0].content;
                   that.stopTime = res.data.result.result[0].deadline;
                   that.getList();
                   that.showImg();
                };
                this.ajaxPostWX(params);
            },
            getPeopleList(){
            	this.modal2 = true;
				let that = this;
		        let params = {};
		        params.data = {
		          order: { _id: -1 },
		          searchValue: {
		          	id : this.id,
		          	is_join:true,
		          }
		        };
		        params.url = "/sys/receiveuser/list";
		        params.token = "swgykj9527";
		        params.success = function(res) {
		            console.log(res);
		            that.peopleList = res.data.result.result;
		        };
		        this.ajaxPost(params);
            }
        },
        beforeDestroy(){
        	var ele = document.getElementsByClassName("ml-i-view");
        	for(var i=0;i<ele.length;i++){
        		ele[i].style.display = "none";
        	}
        },
        mounted: function() {
        	this.SET_LOADING("yes");
            this.getContent();
            if(this.stopTime < new Date().format("yyyy-MM-dd hh:mm:ss")){
                this.isOldB = true;
            }
        }
    }
</script>

<style lang="scss">
	.wxSignModal .ivu-modal-footer{
		display: none;
	}
    @import "../../global/css/swiper.scss";
    .wxSign{
        background: url("../../assets/wxBg.png") center -150px no-repeat;
        height: 100%;
        font-size: 4vw;
        .swiperCss{
        	text-align: center;
        	max-height: 30vh;
        	img{
        		margin: 0 auto;
		    	width: 90%;
        	}
        }
        .ql-editor img{
	    	max-width: 100%;
	    }
        .bgShow{
            background: #fff;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 100%;
            width: 90%;
            padding-top: 10vw;
            margin: 0 auto;
            h3{
            	line-height: 10vw;
            	font-size: 7vw;
            	text-align: center;
            	color: #414141;
            }
            .rightConL{
            	text-align: center;
            	height: 50vw;
            }
            Button{
                width: 70%;
                font-size: 4.5vw;
                height: 13vw;
            }
            .content{
            	font-size: 4.3vw;
            	color: #706767;
            }
            .leftName{
                line-height: 12vw;
                font-size: 4vw;
                height: 12vw;
                text-align: center;
                color: #706767;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/infoMana/wxSign.vue